import React, { useState } from "react";

import {
  FieldContainer,
  RadioGroup,
  RadioItem,
  SubFieldContainer,
  CustomSelect,
  Option,
} from "../../components/CustomFields";

import DetailImageModal from "../../components/Modal/DetailImageModal";

import VeggieHeroImage from "../../assets/images/Veggie_hero.png";
import VegSpoonImage from "../../assets/images/veg_spoon_unit.png";

import InformWarper from "./InformWarper";

export const vegetableOptions = new Array(11)
  .fill(0)
  .map((_, i) =>
    i < 10
      ? { value: i + 1, label: `${i + 1} ช้อนโต๊ะ` }
      : { value: i + 1, label: `มากกว่า 10 ช้อนโต๊ะ` }
  );

const Vegetable = ({ form = {} }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <InformWarper
      name="สุขชัวร์ เพิ่มผัก"
      desc="วันละ 6-12 ช้อนโต๊ะ"
      icon={VeggieHeroImage}
      heroLabel="Veggie Hero ชวนศึกษา"
      leftButton="สุขชัวร์ เพิ่มผัก"
      rightButton="เมนูผัก ดี๊ดี"
      onLeftButtonClick={() => {
        window.open("/article/veggie?key=read");
      }}
      onRightButtonClick={() => {
        window.open("/article/veggie?key=think");
      }}
      onDescClick={() => setModalVisible(true)}
    >
      <FieldContainer
        name="haveEatenVegetable"
        label="เมื่อวานนี้ทั้งวัน ท่านกินผักทุกประเภท ผักสีขาว เขียว เหลือง ส้ม ม่วง  รวมทั้งวัน ได้ปริมาณ กี่ช้อนโต๊ะ"
      >
        <RadioGroup>
          <RadioItem value={false}>
            ไม่ได้กิน หรือ กินน้อยกว่า 1 ช้อนโต๊ะ
          </RadioItem>
          <RadioItem value={true}>กิน</RadioItem>
        </RadioGroup>
      </FieldContainer>
      {form.haveEatenVegetable && (
        <SubFieldContainer>
          <FieldContainer name="vegetableCount" label="">
            <CustomSelect placeholder="โปรดระบุ" allowClear>
              {vegetableOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
        </SubFieldContainer>
      )}
      <DetailImageModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        img={VegSpoonImage}
        topic="ตัวอย่าง ผัก อย่างละ 1 ช้อนโต๊ะ"
        remark={`ด้วยความอนุเคราะห์ภาพถ่ายผัก อย่างละ 1 ช้อนโต๊ะ จากกลุ่มพัฒนาอนามัยแม่และเด็กศูนย์อนามัยที่ 5 ราชบุรี`}
      />
    </InformWarper>
  );
};

export default Vegetable;
